export default {
    white: "#FFFFFF",
    black: "#000000",
    back: "#F8F8F8",
    back2: "#F8F8F8"
};